<div class="tab-pane" uib-tab-content-transclude="tab">
  <app-dealer-report-search-view [profile]="profile"></app-dealer-report-search-view>
</div>
